// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "tag-1F1K8";
var _3 = "percent-2E4g7";
export { _1 as "__esModule", _2 as "tag", _3 as "percent" }
export default { "__esModule": _1, "tag": _2, "percent": _3 }
